import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Package,
  Wrench,
  Clipboard,
  User,
  Activity,
  LogOut,
} from "lucide-react";

const Sidebar = ({ setActivePage, permissions = [] }) => {
  const { pathname } = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));

  const isAdmin = user?.role === "admin";

  // ================= ADMIN MENU =================
  const adminMenu = [
    { path: "/admin/dashboard", label: "Dashboardi", icon: <LayoutDashboard size={26} /> },
    { path: "/admin/products", label: "Produkte", icon: <Package size={26} /> },
    { path: "/admin/parts", label: "Pjeset", icon: <Wrench size={26} /> },
    { path: "/admin/orders", label: "Porosite", icon: <Clipboard size={26} /> },
    { path: "/admin/repairs", label: "Riparime", icon: <Wrench size={26} /> },
    { path: "/admin/analysis", label: "Analiza", icon: <Activity size={26} /> },
    { path: "/admin/settings", label: "Konfigurime", icon: <User size={26} /> },
  ];

  // ================= USER MENU =================
  const userMenu = [
    { page: "dashboard", label: "Dashboardi", icon: <LayoutDashboard size={26} /> },
    { page: "products", label: "Produkte", icon: <Package size={26} /> },
    { page: "parts", label: "Pjese", icon: <Wrench size={26} /> },
    { page: "orders", label: "Porosi", icon: <Clipboard size={26} /> },
    { page: "settings", label: "Konfigurime", icon: <User size={26} /> },
  ];

  const allowedUserMenu = userMenu.filter(
    (item) =>
      item.page === "dashboard" || permissions.includes(item.page)
  );

  return (
    <aside className="fixed top-0 left-0 h-screen w-64 bg-gradient-to-b from-blue-700 to-blue-900 text-white flex flex-col">

      <div className="py-6 text-center font-bold border-b border-blue-500">
        {isAdmin ? "Admin Panel" : "User Panel"}
      </div>

      <div className="text-center py-3 text-sm text-blue-200">
        {user?.username}
      </div>

      <nav className="flex-1 flex flex-col gap-2 px-3">

        {/* ADMIN */}
        {isAdmin &&
          adminMenu.map((item) => {
            const isActive = pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl
                  ${isActive ? "bg-white text-blue-700 font-bold" : "hover:bg-blue-600"}`}
              >
                {item.icon}
                {item.label}
              </Link>
            );
          })}

        {/* USER */}
        {!isAdmin &&
          allowedUserMenu.map((item) => (
            <button
              key={item.page}
              onClick={() => setActivePage && setActivePage(item.page)} // 🔥 SAFE
              className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-blue-600"
            >
              {item.icon}
              {item.label}
            </button>
          ))}
      </nav>

      <div className="p-4 border-t border-blue-500">
        <button
          onClick={() => {
            localStorage.clear();
            window.location.href = "/login";
          }}
          className="w-full flex items-center gap-2 px-4 py-2  rounded"
        >
          <LogOut size={18} />
          Dil
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;